<template>
  <div>
    <van-popup class="send-main" v-model="emailShow">
        <div class="send-email-container">
            <div class="top-email-icon">
                <img :src="cdnUrl + 'FilHTOf1VJ166nG_cv-EygyZ3UBJ'" class="email-icon" alt="">
                <p>发送资料到指定邮箱</p>
            </div>
            <div class="email-form">
                <div class="item">
                    <div class="content">
                        <div class="left-icon">
                            <i class="iconfont icon-youxiang"></i>
                        </div>
                        <div class="right-input">
                            <input type="email" placeholder="请输入邮箱" v-model="email" @blur="blurChange">
                        </div>
                    </div>
                </div>
            </div>
            <button class="send-container" @click.stop="sendShare">确认分享</button>
        </div>
    </van-popup>
    <!-- 确定框 -->
    <message ref="sureMessage" :title="tipOk"></message>
  </div>
</template>

<script>
import { sendEmail } from '@/api/polymerize';
import message from '@/views/polymerize/components/message'
export default {
    components: { message },
    props: {
        pdfIds: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            emailShow: false, // 邮件显示
            email: '',
            tipOk: '下载成功',
            downorshare: '',// 1 下载 2 分享
        }
    },
    created() {
        this.groupId = this.$route.query.id
       
    },
    methods: {
        showEmail() {
            this.emailShow = true
            // console.log('邮件的下载',this.downorshare);
            this.downorshare == '1'? this.tipOk = '下载成功': this.tipOk = '分享成功'
        },
        blurChange() {

        },
        sendShare() {
            // console.log('邮件',this.email,this.pdfIds,this.groupId);
            if (this.email.indexOf('@') == -1) {
                this.$toast('请填写正确的邮箱地址')
                return
            }
            this.$emit('setEmail',this.email)
            this.$toast.loading({
                message: '发送中...',
                forbidClick: true,
                duration: 0
            })
            let lastEmail = this.email.split(',')
            // console.log('看看',lastEmail);
            let para = {
                email: lastEmail,
                pdf_ids: this.pdfIds,
                group_id: this.groupId
            }
            sendEmail(para).then(res => {
                this.$toast.clear()
                this.emailShow = false
                this.$refs.sureMessage.showMessge(this.downorshare)
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.send-main {
    border-radius: 4px;
}
.send-email-container{
    width: rem(297);
    background: #fff;
    margin: 0 auto;
    padding: rem(42) 24px rem(38);
}
.send-email-container .top-email-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #2C2C2C;
    font-size: 12px;
    margin-bottom: rem(50);
    p {
        font-size: 20px;
    }
}
.send-email-container .top-email-icon .email-icon{
    width: 68px;
    height: 68px;
    margin-bottom: rem(4);
}
.send-email-container .email-form{
    margin-bottom: rem(38);
}
.send-email-container .email-form .item .hint-title {
    color: #2c2c2c;
    font-size: 12px;
    display: inline-block;
    margin-bottom: 5px; }
.send-email-container .email-form .item .hint-title .sign {
    color: #d01818; }
.send-email-container .email-form .item .content {
    display: flex;
    align-items: center;
    width: 100%;
    height: rem(38);
    background: #f5f5f5;
    border-radius: 4px;
    margin-bottom: 5px; }
.send-email-container .email-form .item .content .left-icon {
    width: 15%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative; }
.send-email-container .email-form .item .content .left-icon .iconfont {
    color: #5A5A68;
    font-size: 18px; 
    }
.send-email-container .email-form .item .content .left-icon .icon-xingming {
    font-size: 15px; }
.send-email-container .email-form .item .content .left-icon:after {
    content: '';
    width: 1px;
    height: 18px;
    background: #afafaf;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -9px; }
.send-email-container .email-form .item .content .right-input {
    width: 85%;
    padding: 0 10px; }
.send-email-container .email-form .item .content .right-input input {
    width: 100%;
    height: 30px;
    font-size: 14px;
    border: none;
    background: none; }
.send-email-container .send-container{
    width: rem(219);
    height: rem(49);
    background: #6CC5DB;
    color: #FEFEFE;
    font-size: 14px;
    outline: none;
    border: none;
    border-radius:4px;
    display: block;
    margin: 0 auto;
}
</style>